<template>
  <div class="module-loading-overlay" v-bind="$attrs" v-on="$listeners">
    <div class="overlay_loading">
      <lottie-vue-player
        autoplay
        loop
        backgroundColor="transparent"
        mode="normal"
        :src="`${VUE_APP_PUBLIC_PATH}lotties/layout/loading.json`"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "moduleLoadingOverlay",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      VUE_APP_PUBLIC_PATH: process.env.VUE_APP_PUBLIC_PATH
    };
  },
  updated() {
    if (this.loading) {
      document.querySelector("#app").classList.add("loading");
    } else {
      document.querySelector("#app").classList.remove("loading");
    }
  }
};
</script>

<style lang="scss">
@keyframes fade-in {
  from {
    z-index: -1;
    background-color: rgba($color-white, 0);
    opacity: 0;
  }
  to {
    z-index: $z-index-loading;
    background-color: rgba($color-white, 0.8);
    opacity: 1;
  }
}
@keyframes fade-out {
  from {
    z-index: $z-index-loading;
    background-color: rgba($color-white, 0.8);
    opacity: 1;
  }
  to {
    z-index: -1;
    background-color: rgba($color-white, 0);
    opacity: 0;
  }
}

#app {
  &.loading {
    position: absolute;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    .module-loading-overlay {
      animation: fade-in 0.3s ease-in-out forwards;
    }
  }
  &:not(.loading) {
    .module-loading-overlay {
      animation: fade-out 0.3s ease-in-out forwards;
    }
  }
}

.module-loading-overlay {
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  user-select: none;
  cursor: wait;
  display: flex;
  align-items: center;
  justify-content: center;

  .overlay_loading {
    width: 200px;
    pointer-events: none;
  }
}
</style>
